import { render, staticRenderFns } from "./new-city-order.vue?vue&type=template&id=38e130c6&scoped=true&"
import script from "./new-city-order.vue?vue&type=script&lang=js&"
export * from "./new-city-order.vue?vue&type=script&lang=js&"
import style0 from "./new-city-order.vue?vue&type=style&index=0&id=38e130c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e130c6",
  null
  
)

export default component.exports